import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoSearch } from "react-icons/io5";
import { Table, Pagination } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import Popup from "reactjs-popup";
import { createUsersDetails, deleteUser, editUser, usersDetails } from "../../services/ApiServices";
import ToastMsg from "../../component/comman/ToastMsg";
import sort from "../../assets/sort.svg";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";

var order = ""

function Users() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [pageInfo, setPageInfo] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });
  const [editUserData, setEditUserData] = useState({
    id: "",
    role: "",
    name: "",
    // mobile_no: "",
    email: "",
  });
  const closeModal = () => {
    setOpen(false);
    setIsEditMode(false)
    setFormData({
      role: "",
      name: "",
      // mobile_no: "",
      email: "",
    });
  };
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    role: "",
    name: "",
    // mobile_no: "",
    email: "",
  });

  useEffect(() => {
    setFilteredCustomers(users);
    setTotalPages(Math.ceil(users.length / itemsPerPage));
  }, [users, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getUsersDetails = useCallback((params = {}) => {
    const queryParams = { ...params, filter_value: searchTerm, page_num: currentPage, per_page_data: itemsPerPage };
    if (order != ""){
      queryParams["order"] = order
    }
    usersDetails(queryParams)
      .then((res) => {
        if (res.status === 200 && res.data && Array.isArray(res.data.data)) {
          setUsers(res.data.data);
          setPageInfo(res?.data?.page_info);
        } else {
          console.error("API response is not an array:", res?.data);
          setUsers([]);
        }
      })
      .catch((err) => {
        setUsers([]);
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  }, [navigate, searchTerm, currentPage, itemsPerPage]);

  useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
        getUsersDetails();
      }, 500);
    
      return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, getUsersDetails]);

  const handleSort = (sortOrder) => {
    const params = { order: sortOrder };
    order = sortOrder
    getUsersDetails(params);
  };

  useEffect(() => {
    getUsersDetails();
  }, [getUsersDetails, currentPage, itemsPerPage]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (isEditMode) {
      setEditUserData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;
    const nameParts = (isEditMode ? editUserData.name : formData.name).trim().split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";
  
    const userData = {
      ...(isEditMode ? editUserData : formData),
      first_name: firstName,
      last_name: lastName,
    };
  
    delete userData.name;
  
    if (isEditMode) {
      // Call API to update user
      editUser(userData).then((res) => {
        closeModal();
        getUsersDetails();
      }).catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "Something went wrong";
        ToastMsg(error, "error");
      });
    } else {
      // Call API to create user
      createUsersDetails(userData).then((res) => {
        closeModal();
        getUsersDetails();
      }).catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "Something went wrong";
        ToastMsg(error, "error");
      });
    }
  };

  console.log(customerId, "ghjkl");
  

  const handleDeleteUser  = useCallback((id) => {
    if (!id) {
      ToastMsg("No customer selected for deletion", "error");
      return;
    }
    const updatedData = {
      id: id,
    };
  
    deleteUser (updatedData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("User  deleted successfully", "success");
          getUsersDetails();
          setCustomerId(null);
        } else {
          ToastMsg("Failed to delete user", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });
  }, [getUsersDetails]);
  
  useEffect(() => {
    if (customerId) {
      handleDeleteUser (customerId);
    }
  }, [customerId, handleDeleteUser ]);

  const checkFormValidity = useCallback(() => {
    const data = isEditMode ? editUserData : formData;
    const isValid = data.role && data.name && data.email;
    setIsFormValid(!!isValid);
  }, [formData, editUserData, isEditMode]);

  useEffect(() => {
    checkFormValidity();
  }, [formData, editUserData, isEditMode, checkFormValidity]);

  return (
    <>
      <div className="dasboard-content">
        <div className="card mb-4">
          <div className="card-body">
            <div className="search-sc d-flex align-items-center justify-content-between">
              <form>
                <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                  <IoSearch className="search-icon" />
                </div>
              </form>
              <button className="btn" onClick={() => setOpen((o) => !o)}>
                + New User
              </button>
            </div>

          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="card-header d-flex align-items-center justify-content-end">
              <div className="filter d-flex align-items-center">
              <div className="dropdown">
                <button className="flex align-items-center">
                  <span>Sort</span>
                  <img src={sort} alt="icon" width={18} height={15} />
                </button>
                <div className="subMenu">
                  <ul>
                    <li onClick={() => handleSort('first_name')}>Name<TiArrowSortedDown/> </li>
                    <li onClick={() => handleSort('-first_name')}>Name <TiArrowSortedUp/></li>
                    <li onClick={() => handleSort('email')}>Email <TiArrowSortedDown/></li>
                    <li onClick={() => handleSort('-email')}>Email <TiArrowSortedUp/></li>
                    <li onClick={() => handleSort('role')}>Role <TiArrowSortedDown/></li>
                    <li onClick={() => handleSort('-role')}>Role <TiArrowSortedUp/></li>
                  </ul>
                </div>
              </div>
              </div>
            </div>
            <div className="table-responsive users">
              <Table className="table-centered table-striped table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: "pointer" }}>ID</th>
                    <th style={{ cursor: "pointer" }}>Name</th>
                    <th style={{ cursor: "pointer" }}>Email</th>
                    <th style={{ cursor: "pointer" }}>Role</th>
                    <th style={{ cursor: "pointer" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    filteredCustomers.slice(
                      (currentPage - 1) * itemsPerPage,
                      currentPage * itemsPerPage
                    )
                    .map((user, index) => (
                      <tr key={index}>
                        <td>{user.id}</td>
                        <td>{user.first_name + " " + user.last_name}</td>
                        <td>{user.email}</td>
                        <td>{user.role}</td>
                        <td>
                          <FaRegEdit 
                            style={{cursor: "pointer"}} 
                            onClick={() => {
                              setIsEditMode(true);
                              setEditUserData({
                                id: user.id,
                                role: user.role,
                                name: user.first_name + " " + user.last_name,
                                mobile_no: user.mobile_no,
                                email: user.email,
                              });
                              setOpen(true);
                            }}
                          />
                          <RiDeleteBin5Fill 
                            style={{ cursor: "pointer" }} 
                            onClick={() => {
                              setCustomerId(user.id);
                              handleDeleteUser (user.id);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
              <div className="d-flex justify-content-between align-items-center border-top pagination-wrapper">
                <div className="text-muted small">
                  {(currentPage - 1) * itemsPerPage + 1}-
                  {10*(currentPage - 1) + filteredCustomers.length}
                  {" "}of {pageInfo.total_data || "0"}
                </div>
                <div className="d-flex align-items-center">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="itemsPerPage">Rows per page:</label>
                    <select
                      id="itemsPerPage"
                      className="form-control"
                      value={itemsPerPage}
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <MdOutlineKeyboardArrowDown />
                  </div>
                  <Pagination size="sm" className="pagination-rounded mb-0">
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    <p>
                      <span>{currentPage}</span>/{pageInfo.total_pages}
                    </p>
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === pageInfo.total_pages}
                    />
                  </Pagination>
                </div>
              </div>
          </div>
        </div>
      </div>
      <Popup open={open || isEditMode} closeOnDocumentClick={false} onClose={closeModal} className='new-user'>
        <div className='card'>
          <div className='card-body'>
            <div className='flex align-items-center justify-content-between'>
              <h5>{isEditMode ? "Edit User" : "Create New User"}</h5>
              <IoClose onClick={closeModal}/>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="role">Role</label>
                <select
                    id="role"
                    className="form-control"
                    value={isEditMode ? editUserData.role : formData.role}
                    onChange={handleInputChange}
                    disabled={isEditMode}
                >
                    <option>Select User</option>
                    <option value="Admin">Admin</option>
                    <option value="Employee">Employee</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  placeholder='Name'
                  value={isEditMode ? editUserData.name : formData.name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="mobile_no">Mobile Number</label>
                <input
                  type="number"
                  id="mobile_no"
                  className="form-control"
                  placeholder='Mobile Number'
                  value={isEditMode ? editUserData.mobile_no : formData.mobile_no}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder='Email'
                  value={isEditMode ? editUserData.email : formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <div className='button-wrapper text-right'>
                <button type="submit" className='btn'>{isEditMode ? "Update User" : "Create User"}</button>
              </div>
            </form>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default Users;